import { render, staticRenderFns } from "./chusao.vue?vue&type=template&id=710cc96b&scoped=true&"
import script from "./chusao.vue?vue&type=script&lang=js&"
export * from "./chusao.vue?vue&type=script&lang=js&"
import style0 from "./chusao.vue?vue&type=style&index=0&id=710cc96b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710cc96b",
  null
  
)

export default component.exports